const SET_IDENTITY = (state, data) => {
  state.identity = data;
  state.identity.birthDate = data.birthDate && data.birthDate.split('-').reverse().join('.');
  state.identity.documentIssueDate = data.documentIssueDate && data.documentIssueDate.split('-').reverse().join('.');
};

const SET_COUNTRIES = (state, list) => {
  state.countries = list;
};

const SET_RESET = (state, status) => {
  state.identity.firstName = '';
  state.identity.secondName = '';
  state.identity.patronymic = '';
  state.identity.status = status;
};

const SET_IDENTIFICATION_STATUS = (state, status) => {
  state.identification.status = status;
};

export default {
  SET_IDENTITY,
  SET_COUNTRIES,
  SET_RESET,
  SET_IDENTIFICATION_STATUS,
};
